import React from 'react';
import { Hero } from './sections/Hero';
import { WhatWeDo } from './sections/WhatWeDo';
import { ProofStrip } from './sections/ProofStrip';
import { FeaturedProjects } from './sections/FeaturedProjects';
import { SectorsPreview } from './sections/SectorsPreview';
import { InsightsTeaser } from './sections/InsightsTeaser';
import { ContactStrip } from './sections/ContactStrip';

export const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <WhatWeDo index={0} />
      <ProofStrip index={1} />
      <FeaturedProjects index={2} />
      <SectorsPreview index={3} />
      <InsightsTeaser index={4} />
      <ContactStrip index={5} />
    </>
  );
};

